const configs = {
    test: {
        env: "test",
        baseUrl: "https://backend-stg.apna.co",
        legacyBaseUrl: "https://backend-stg.apna.co",
        telecallingAssesmentQuestionId: "8577",
        deliveryAssesmentQuestionIds: {
            drivingLicense: "-55",
            bike: "-2",
        },
    },
    production: {
        env: "production",
        baseUrl: "https://production.apna.co",
        legacyBaseUrl: "https://production.apna.co",
        telecallingAssesmentQuestionId: "111182",
        deliveryAssesmentQuestionIds: {
            drivingLicense: "-55",
            bike: "-2",
        },
    },
}

const env = (import.meta.env.VITE_ENV as keyof typeof configs) || "test"

export const config = {
    ...configs[env],
} as const
